import type { VoicePreviewPayload } from './types';
import { WorkspaceMarkdown } from './markdown';

export function VoicePreview({ preview }: { preview: VoicePreviewPayload }) {
  return (
    <div className="ws-canvas-body ws-voice-preview" data-testid="voice-preview">
      <h2>{preview.title}</h2>
      {preview.kind === 'table' || preview.kind === 'comparison' ? (
        <div className="ws-table-scroll" tabIndex={0} aria-label={preview.title}>
          <table>
            <thead>
              <tr>
                {preview.columns.map((column, index) => (
                  <th key={`${column}-${index}`} scope="col">
                    {column}
                  </th>
                ))}
              </tr>
            </thead>
            <tbody>
              {preview.rows.map((row, index) => (
                <tr key={index}>
                  {row.map((cell, cellIndex) => (
                    <td key={cellIndex}>{cell}</td>
                  ))}
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      ) : 'markdown' in preview ? (
        <div className="ws-canvas-body" tabIndex={0} aria-label={preview.title}>
          <WorkspaceMarkdown text={preview.markdown} />
        </div>
      ) : null}
    </div>
  );
}
